import {Injectable} from "@angular/core";
import {BusinessPlanQuery, BusinessPlanType} from "@generated/graphql";
import {map, Observable} from "rxjs";
import {businessPlanFactory} from "@modules/account-settings/pages/business-profile/factories/business-plan.factory";
import {BusinessPlan} from "@modules/account-settings/pages/business-profile/models/business-plan.model";

@Injectable({
  providedIn: 'root'
})
export class BusinessPlanApi {
  constructor(
    protected readonly businessPlanQuery: BusinessPlanQuery
  ) {
  }

  get businessPlanQueryRef() {
    return this.businessPlanQuery.watch(null,{fetchPolicy: 'no-cache'})
  }

  get$(): Observable<BusinessPlan> {
    return this.businessPlanQueryRef.valueChanges.pipe(
      map(res => res.data.businessPlan ? businessPlanFactory.create(res.data.businessPlan as BusinessPlanType) : null)
    )
  }
}
